import styled from 'styled-components';

import { LinkButton } from '@/components/Shared/Buttons';

/** The shared link-like button, sized for the notice. */
export const NoticeLinkButton = styled(LinkButton)`
  padding: 0;
  font-size: 13px;
  text-transform: none;
  /* a long label wraps inside the row instead of being centered */
  text-align: left;
`;
